module.exports = __webpack_public_path__ + "img/treviso.41ff91c5.png";